import api from './interceptor';

const BASE_URL_V2 = 'api/v2/waiting-room';

export default {
  // API Version 2
  getUrgentWaitingRoomFiles: clinicId => api.get(`${BASE_URL_V2}/${clinicId}/upload/urgent`),
  deleteUrgentWaitingRoomFile: docId => api.delete(`${BASE_URL_V2}/upload/urgent/${docId}`),
  uploadUrgentWaitingRoomFile: (clinicId, body) => api.post(`${BASE_URL_V2}/${clinicId}/upload/urgent`, body),
  getAppointmentWaitingFiles: appointmentId => api.get(`${BASE_URL_V2}/upload/${appointmentId}`),
  getProviderWaitingRoomFiles: (providerId) => api.get(`${BASE_URL_V2}/${providerId}/upload/provider`),
  uploadProviderWaitingRoomFile: (providerId, body) => api.post(`${BASE_URL_V2}/${providerId}/upload/provider`, body),
  deleteProviderWaitingRoomFile: (uploadId) => api.delete(`${BASE_URL_V2}/upload/provider/${uploadId}`),
};
